<template>
        <div>
            <div class="btn-tool align-right">
                <div class="table-title">
                    <ih7 :cfg="{label:$t('操作履历')}"></ih7>
                </div>
            </div>
            <Table size="small" border ref="listTable" :columns="columns" :data="tableData" height="450"> </Table>
            <page v-bind:pageVO='pageVO' @pageVOChange='pageVOChange'></page>
            <div class="btn-tool align-center">
                <Button type="primary" @click="handleClose" size="large">{{$t('关闭')}}</Button>
            </div> 
        </div> 
</template>
<script>
export default {
    props: {
        tabelSelect: Object,
    },
    data () {
        return {
            pageVO: { curPage: 1, pageSize: 10, totalRows: 10 },
            formCustom: {
            },
            tableData: [],
            columns: []
        }
    },
    //初始化后调用
    created () {
        //给表单赋值
        this.$utils.getFormAttrValue(this.formCustom,this.tabelSelect,true)
        this.setTablechannelLiableTitle();
        this.handleSubmit()
    },
    methods: {
        //设置表格的列设置
        setTablechannelLiableTitle () {
            var self = this;
            const columns = [
                {
                    title: self.$t('com.serialNumber'),
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: self.$t('操作明细'),
                    key: 'operationDesc',
                    width: 640
                },
                {
                    title: self.$t('操作人'),
                    key: 'lastUpdatedBy',
                    width: 340,
                    format: {
                        label: "displayname",
                        key: "uuid",
                        dataCfg: {
                            sc: "user",
                            paramsStr: "uuidString",
                            url: "userManager/getUserByUUIDStringLocal"
                        }
                    }
                },
                {
                    title: self.$t('操作时间'),
                    key: 'lastUpdateDate',
                    width: 340
                }
            ]
            this.columns = columns;
        },
        //查询
        handleSubmit () {
            let pageVO = this.pageVO,
                self = this,
                urlStr=self.tabelSelect.ruleType=='POINTS'||self.tabelSelect.ruleType=='GROWTH'?'memberOperationLogManage/listOperationLogPointsPaging':'memberOperationLogManage/listOperationLogPaging',
                params = {
                curPage: pageVO.curPage,
                pageSize: pageVO.pageSize,
                filter: { bussinessId: self.tabelSelect.id ,bussinessType:self.tabelSelect.bussinessType}
            };
            this.$api.post({
                url:urlStr,
                sc:'member',
                params:params,
                success:r=>{
                    const list = r.result || [];
                    self.tableData = r.result;
                    if (list.length > 0) { Object.assign(pageVO, list[0].pagingMap) }
                    else { self.pageVO.curPage = -1 };
                    }
            })
        },
        //分页子组件值改变触发该方法
        pageVOChange (pageVO) {
            Object.assign(this.pageVO, pageVO);
            this.handleSubmit();
        },
        //关闭
        handleClose(){
            let self=this;
            self.$emit('handleClose',self.$parent.name);
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/page/publicResume/resume.vue